import * as React from "react"

const SvgInformationCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 17.857q.424 0 .713-.287a.97.97 0 0 0 .287-.713v-4a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v4a.97.97 0 0 0 .287.713q.288.287.713.287m0-8q.424 0 .713-.287A.97.97 0 0 0 13 8.857a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712q0 .425.287.713.288.287.713.287m0 13a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137a9.7 9.7 0 0 1 3.9-.788 9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.787m0-2q3.35 0 5.675-2.325Q20 16.208 20 12.857t-2.325-5.675T12 4.857 6.325 7.182 4 12.857q0 3.35 2.325 5.675T12 20.857" />
  </svg>
)
export default SvgInformationCircle
